export default "__VITE_ASSET__C8eg2LHA__"